export default {
    GET_FOLDING_TYPES_REQUEST: (state) => {
        state.foldingTypesLoading = true
    },
    GET_FOLDING_TYPES_SUCCESS: (state, data) => {
        state.foldingTypes = data.results
        state.foldingTypesLoading = false
    },
    GET_FOLDING_TYPES_FAILURE: (state) => {
        state.foldingTypesLoading = false
    },
    GET_IMPOSITION_TASK_FOLDING_TYPES_REQUEST: (state) => {
        state.impositionTaskFoldingTypesLoading = true
    },
    GET_IMPOSITION_TASK_FOLDING_TYPES_SUCCESS: (state, data) => {
        state.impositionTaskFoldingTypes = data.results
        state.foldingTypesLoading = false
    },
    GET_IMPOSITION_TASK_FOLDING_TYPES_FAILURE: (state) => {
        state.impositionTaskFoldingTypesLoading = false
    },
    SET_LAST_IMPOSITION_TASK_QUERY: (state, query) => {
        state.lastImpositionTaskQuery = query
    },
}